import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import _, { chain, partial, split, isEmpty } from 'lodash';

import { routes } from '../../routes';
import { PATH } from '../../constants/path';
import { LOCALES, DEFAULT_LOCALE } from '../../constants/locale';
import { MODAL_TYPE_LOGIN } from '../../services/modal/constants';
import { APPLICATION_ID, SSO_URL, CFC_IDS } from '../../constants';
import { STORAGE_KEY_DYNAMIC_USER_ID } from '../../constants/storage';

import {
    registerAdBlockerDetection,
    registerCookieDetection
} from '../../services/adblocker/actions';
import { showModal } from '../../services/modal/actions';
import { changeCurrentLocale } from '../../services/i18n/actions';
import { fetchPartnersIfNeeded } from '../../services/partner/actions';
import { fetchCategoriesIfNeeded } from '../../services/category/actions';
import { fetchEbonPartners, decodeCfcToken } from '../../services/ebon/actions';

import {
    catchClickId,
    catchRedirectUri,
    catchScoreHash,
    catchUserId,
    getUserId,
    catchSource
} from '../../utils/plebicardUtils';
import { mapRoutes } from '../../utils/routeUtils';
import { getLocaleFromRoutes } from '../../services/i18n/utils';
import { clearSessionStorageKey, getStorageKey } from '../../utils/storageUtils';

const ConnectedSwitch = connect(state => ({
    location: state.location
}))(Switch);

class RouterComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { checkLogin: false };
    }

    componentWillMount() {
        this.changeCurrentLocaleIfNeeded(this.props);
        const {
            location: { search, pathname },
            showModal,
            decodeCfcToken
        } = this.props;

        const values =
            search &&
            chain(search)
                .replace('?', '') // a=b454&c=dhjjh&f=g6hksdfjlksd
                .split('&') // ["a=b454","c=dhjjh","f=g6hksdfjlksd"]
                .map(partial(split, _, '=', 2)) // [["a","b454"],["c","dhjjh"],["f","g6hksdfjlksd"]]
                .fromPairs() // {"a":"b454","c":"dhjjh","f":"g6hksdfjlksd"}
                .value();

        const redirectUri = values && values.redirect_uri;
        const label = values && values.label;
        const userId = values && values.userId;
        const clickId = values && values.clickId;
        const score = values && values.score;
        const hash = values && values.hash;
        const source = values && values.source;

        // For CFC
        const accesspleb = values && values.accesspleb;

        if (CFC_IDS.includes(APPLICATION_ID) && !pathname.includes(PATH.EBON_DOWNLOAD_BILL_PATH)) {
            const storedUserId = getUserId();

            if (accesspleb) {
                decodeCfcToken(accesspleb);
            }

            if (!storedUserId && !accesspleb) {
                setTimeout(() => {
                    showModal(MODAL_TYPE_LOGIN, {
                        redirectUrl: SSO_URL,
                        hideCloseButton: true
                    });
                }, 200);
            }
        }

        // Do not catch this params for CFC
        if (!CFC_IDS.includes(APPLICATION_ID)) {
            catchRedirectUri(redirectUri, label);
            catchUserId(userId);
            catchClickId(clickId);
        }
        catchScoreHash(score, hash);
        catchSource(source);
    }

    componentDidMount() {
        const { fetchPartnersIfNeeded, fetchCategoriesIfNeeded, fetchEbonPartners } = this.props;

        fetchPartnersIfNeeded();
        fetchCategoriesIfNeeded();
        fetchEbonPartners();

        setTimeout(() => {
            this.setState({ checkLogin: true });
        }, 200);
    }

    componentDidUpdate(prevProps) {
        const { location, showModal, cfcDecodeFetch, cfcTokenValid, cfcPersonneId } = this.props;
        const { checkLogin } = this.state;

        if (prevProps.location !== location) {
            this.changeCurrentLocaleIfNeeded(this.props);
        }

        /* 
            When going back from Monetico page to merchant card using Browser'back button,
            Monetico scripts are not reloading themselves, which cause a blank page
            For now, we reload the page to force the reset.
        */
        if (
            prevProps.location.pathname.includes(PATH.EBON_VALIDATION_PATH) &&
            location.pathname.includes(PATH.MERCHANTPAGE_EBON_PATH)
        ) {
            window.location = `${location.pathname}${location.hash ? location.hash : ''}`;
            window.location.reload(true);
        }

        // For CFC
        const storageKey = getStorageKey(STORAGE_KEY_DYNAMIC_USER_ID);
        const storedUserId = getUserId();

        if (CFC_IDS.includes(APPLICATION_ID)) {
            if (prevProps.cfcDecodeFetch && !cfcDecodeFetch) {
                if (cfcTokenValid && cfcPersonneId) {
                    catchUserId(cfcPersonneId);
                } else {
                    clearSessionStorageKey(storageKey);
                    showModal(MODAL_TYPE_LOGIN, {
                        redirectUrl: SSO_URL,
                        hideCloseButton: true
                    });
                }
            } else if (
                checkLogin &&
                !cfcDecodeFetch &&
                !storedUserId &&
                !location.pathname.includes(PATH.EBON_DOWNLOAD_BILL_PATH)
            ) {
                clearSessionStorageKey(storageKey);
                showModal(MODAL_TYPE_LOGIN, {
                    redirectUrl: SSO_URL,
                    hideCloseButton: true
                });
            }
        }
    }

    changeCurrentLocaleIfNeeded({ pathname, locale }) {
        // On vient mettre à jour le store si on arrive avec une url d'un autre langage
        const newLocale = getLocaleFromRoutes(pathname, LOCALES, DEFAULT_LOCALE);

        if (newLocale !== locale) {
            this.props.changeCurrentLocale(newLocale);
            moment.locale(newLocale);
        }
    }

    render() {
        return <ConnectedSwitch>{mapRoutes(routes)}</ConnectedSwitch>;
    }
}

const mapStateToProps = state => {
    return {
        pathname: state.routing.location.pathname,
        locale: state.i18n.locale,
        isAuthed: !isEmpty(state.authentication.token),
        isAuthFetching: state.authentication.fetching,
        cfcTokenValid: state.ebon.cfcDecodeState.valid,
        cfcPersonneId: state.ebon.cfcDecodeState.personneId,
        cfcDecodeFetch: state.ebon.cfcDecodeFetch
    };
};

const mapDispatchToProps = {
    fetchPartnersIfNeeded,
    fetchEbonPartners,
    fetchCategoriesIfNeeded,
    decodeCfcToken,
    changeCurrentLocale,
    showModal,
    registerAdBlockerDetection,
    registerCookieDetection
};

export default connect(mapStateToProps, mapDispatchToProps)(RouterComponent);



// WEBPACK FOOTER //
// ./src/components/router/RouterComponent.js